import _                from 'lodash'
import PropTypes        from 'prop-types'
import React            from 'react'
import { withRouter   } from 'react-router'

import { Login                } from 'alto-react-base-auth/lib/components'
import { clientSelectSetting  } from 'alto-react-client-auth/lib/settings'
import { IfContactFormEnabled } from 'alto-react-client-auth/lib/components'
import { InitPasswordResetLink, ResendActivationEmailLink, ContactFormLink } \
  from 'alto-react-client-auth/lib/routes'
import { Client               } from 'alto-react-kredit/lib/models'

import ClientSelect from './client_select'

class ClientLogin extends Login.WrappedComponent
  @contextTypes =
    auth:     PropTypes.object
    backend:  PropTypes.object
    settings: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    clientSelect = clientSelectSetting(context.settings)

    @state.useClientSelect = clientSelect.enabled and not clientSelect.mustAuthenticate
    @neverUseClientSelect  = not @state.useClientSelect

    if @state.useClientSelect
      @state.clients        = null
      @state.selectedClient = null
      @state.clientSearch   = ''

  componentWillMount: ->
    if @state.useClientSelect
      @promise = @context.auth.getClientsForSelect().then ({ clients }) => @setState({ clients })

  componentWillUnmount: ->
    @promise?.cancel()

  usernameLabel: ->
    if @state.useClientSelect then 'Uživatel' else super()

  usernameControl: ->
    if @state.useClientSelect
      <ClientSelect {...@clientSelectProps()} />
    else
      super()

  clientSelectProps: ->
    clients:    @state.clients
    selected:   @state.selectedClient
    searchTerm: @state.clientSearch
    onChange:   (value) => @setState(selectedClient: value) unless _.isEmpty(value)
    onSearch:   (value) => @setState(clientSearch: value)

  additionalInfo: ->
    paragraphs = []

    paragraphs.push(
      <IfContactFormEnabled key='contact-form'>
        <p>
          Nedaří se Vám přihlásit nebo zaregistrovat?&ensp;
          <ContactFormLink>Kontaktujte nás</ContactFormLink>
        </p>
      </IfContactFormEnabled>)

    unless @neverUseClientSelect
      clientSelectSwitch = <p key='client-select-switch'>{@clientSelectSwitch()}</p>

      paragraphs.push(clientSelectSwitch)

    paragraphs

  clientSelectSwitch: ->
    <a href='' onClick={@onClientSelectSwitched.bind(@)}>
      Přihlásit se jako {if @state.useClientSelect then 'administrátor' else 'klient'}
    </a>

  onClientSelectSwitched: (event) ->
    event.preventDefault()

    @setState(useClientSelect: not @state.useClientSelect)

  isUsernameValid: ->
    if @state.useClientSelect then @state.selectedClient else super()

  logIn: ->
    if @state.useClientSelect
      @context.auth.logInClientByCard(@state.selectedClient.cardId, @state.password)
    else
      @context.auth.logInClient(@state.username, @state.password)

export default withRouter(ClientLogin)
